import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react'
import classNames from 'classnames'
import { Fragment, ReactNode } from 'react'

export type Option = {
  id: string
  label: string
  disabled?: boolean
  className?: string
}

type Props = {
  options?: Option[]
  icon?: ReactNode
  handleClick?: (val: Option) => void
  disabled?: boolean
  title?: ReactNode
  titleClassName?: string
  optionClassName?: string
  menuClassName?: string
}

const tableDropdown: Option[] = [
  {
    id: 'edit',
    label: 'Edit'
  },
  {
    id: 'delete',
    label: 'Delete'
  }
]

export const DropMenu = ({
  options,
  handleClick,
  disabled,
  title,
  icon,
  titleClassName,
  optionClassName,
  menuClassName
}: Props) => {
  return (
    <div className="flex">
      <Menu as="div" className="relative">
        <MenuButton
          className={classNames(
            'focus:not-data-focus:outline-none data-focus:outline-none data-focus:outline-white focus:border-primary bottom-1 flex w-full capitalize items-center justify-between gap-2 rounded-md px-4 py-3',
            titleClassName
          )}
          disabled={disabled}
        >
          {title}
          {icon && icon}
        </MenuButton>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <MenuItems
            className={classNames(
              'absolute -end-3 z-50 mt-2 min-w-36 rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none',
              menuClassName
            )}
          >
            {(options || tableDropdown)
              .filter((x: Option) => !x?.disabled)
              .map((option, index) => (
                <MenuItem key={index}>
                  <button
                    className={classNames(
                      'nowh block w-full bg-white px-4 py-2 text-left text-sm hover:bg-gray-100',
                      optionClassName,
                      option.className
                    )}
                    onClick={() => handleClick && handleClick(option)}
                  >
                    {option.label}
                  </button>
                </MenuItem>
              ))}
          </MenuItems>
        </Transition>
      </Menu>
    </div>
  )
}
